import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {from, Observable, of, switchMap, tap} from 'rxjs';
import {NavController} from "@ionic/angular/standalone";
import {AutocloseOverlaysService} from "../services/autoclose-overlay.service";


@Injectable({
  providedIn: 'root'
})
export class ModalGuard {
  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private autocloseOverlaysService: AutocloseOverlaysService,
  ) {
  }


  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._check(route, state);
  }

  private _check(childRoute?: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean> {
    const navState = this._router?.getCurrentNavigation()?.extras?.state;

    // Bypass guard when redirecting due to session expiration
    if (navState?.['sessionExpired']) {
      return of(true);
    }

    // Bypass guard durante il logout: è un teardown totale, la navigazione a /login deve
    // vincere SEMPRE. Senza questo, col menu laterale aperto (dove sta il pulsante Logout)
    // `trigger()` chiuderebbe il menu e restituirebbe true → canDeactivate=false → navigazione
    // annullata: l'utente resta sulla pagina corrente col menu chiuso. La chiusura del menu la
    // fa esplicitamente il chiamante (menu.component.logout).
    if (navState?.['loggingOut']) {
      return of(true);
    }

    // `autoSkip` vale SOLO per le navigazioni imperative, cioè quelle che il codice avvia da sé.
    // Lo state resta scritto nella history entry di destinazione: un tasto indietro che vi
    // ritornasse lo ripresenterebbe (trigger `popstate`) ed esenterebbe la modale dalla chiusura,
    // proprio nel caso in cui il back DEVE chiuderla. Qui il flag viene neutralizzato prima di
    // arrivare al servizio, così l'esenzione non sopravvive nella cronologia.
    const navigazione = this._router?.getCurrentNavigation();
    const statoPerOverlay = navigazione?.trigger === 'imperative'
      ? navState
      : {...navState, autoSkip: false};

    return from(this.autocloseOverlaysService.trigger(statoPerOverlay)).pipe(
      switchMap((value) => {
          return of(!value)
        }
      ),
      tap(() => {
        if (!!navState?.['skip']) {
          this._router.getCurrentNavigation()!.extras.state =
            {...this._router.getCurrentNavigation()!.extras.state, skip: false};
        }
      }),
    )
  }
}
